import { styled, Typography } from "@mui/material";
import { Checkbox } from "@volt_developers/components";

import { TEST_IDS } from "constants/TestIds";

import { useTreeGroupContext } from "../../Tree/TreeGroup";

import type { ReactNode, SyntheticEvent } from "react";

import type { Region } from "models/Region";

export interface RegionLabelProps {
  id: Region["regionCode"];
  isIndeterminate: boolean;
  isSelected: boolean;
  label: ReactNode;
  onClick: (event: SyntheticEvent) => void;
}

export function RegionLabel({
  id,
  label,
  isSelected,
  isIndeterminate,
  onClick,
}: RegionLabelProps) {
  const testId = TEST_IDS.getCheckbox(String(id));
  const { isGroupExpanded } = useTreeGroupContext();

  return (
    <>
      <Arrow sx={{ transform: isGroupExpanded ? "rotate(90deg)" : "none" }} />
      <StyledCheckbox
        checked={isSelected}
        data-testid={testId}
        id={testId}
        indeterminate={isIndeterminate}
        onClick={onClick}
      />
      <Typography color="text.high" variant="h7">
        {label}
      </Typography>
    </>
  );
}

const Arrow = styled("div")(({ theme }) => ({
  width: 0,
  height: 0,
  borderTop: "5px solid transparent",
  borderBottom: "5px solid transparent",
  borderLeft: `5px solid ${theme.palette.text.high}`,
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(2),
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  minWidth: 20,
  marginRight: theme.spacing(1.5),
}));
